var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV1ShruggingCloudIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "287px",
    height: "138px",
    viewBox: "0 0 287 138",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shrugging cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bar-chart-V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1/Empty-states-V2",
    transform: "translate(-774.000000, -382.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(776.430034, 384.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.479833,0.316010969 C173.210433,0.316010969 197.638649,18.7367057 206.598286,44.4118999 L206.748624,44.4072229 L206.748624,44.4072229 L207.310654,44.4011801 C221.604675,44.4011801 233.303186,56.0996911 233.303186,70.3937117 C233.303186,73.6474576 232.657334,76.9011099 231.353434,79.4967131 C235.252938,77.5469613 239.152441,76.9011099 243.051945,76.9011099 L243.050784,76.901011 L243.538058,76.9053128 C259.392469,77.1592065 272.040221,89.807076 272.294113,105.673173 L272.298004,106.159866 C272.298004,122.403638 259.295499,135.406143 243.051727,135.406143 L243.051727,135.406143 L70.8278072,135.406143 C52.6218045,135.406143 38.3277838,121.099644 38.3277838,102.90612 C38.3277838,84.7001172 52.6342829,70.4060966 70.8278072,70.4060966 C73.4236288,70.4060966 75.3732871,70.4060966 77.9688903,71.0519479 C77.3230389,69.1021961 77.3230389,66.4943016 77.3230389,63.8986984 C77.3230389,44.5988232 86.4892581,27.5938032 100.741193,16.964142 C112.364847,6.60876186 127.687465,0.316010969 144.479833,0.316010969 Z",
    id: "Combined-Shape",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.125149,69.1959846 L181.162691,69.1959846 C184.4764,69.1959846 187.162691,71.8822761 187.162691,75.1959846 C187.162691,78.5096931 184.4764,81.1959846 181.162691,81.1959846 L116.125149,81.1959846 C112.81144,81.1959846 110.125149,78.5096931 110.125149,75.1959846 C110.125149,71.8822761 112.81144,69.1959846 116.125149,69.1959846 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(148.643920, 75.195985) rotate(-11.000000) translate(-148.643920, -75.195985) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 117.195924,
    cy: 43.1863282,
    r: 6.82049769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#3F51B5",
    cx: 84.5471509,
    cy: 124.642714,
    r: 6.15807236
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#3F51B5",
    cx: 216.547151,
    cy: 110.226332,
    r: 6.15807236
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#3F51B5",
    cx: 257.543738,
    cy: 67.8782089,
    r: 6.15807236
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#3F51B5",
    cx: 29.5846935,
    cy: 99.4140451,
    r: 6.15807236
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#3F51B5",
    cx: 26.8816218,
    cy: 45.3526116,
    r: 6.15807236
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#3F51B5",
    cx: 258.444762,
    cy: 11.5642157,
    r: 6.15807236
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    cx: 161.604577,
    cy: 35.2027503,
    r: 6.82049769
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.6143345,
    y1: 122.566553,
    x2: 35.8156997,
    y2: 101.392491,
    id: "Line",
    stroke: "#3F51B5",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.075085,
    y1: 105.645051,
    x2: 252.998924,
    y2: 72.7212123,
    id: "Line-Copy-3",
    stroke: "#3F51B5",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.1569966,
    y1: 93.9317406,
    x2: 28.1569966,
    y2: 51.510684,
    id: "Line-Copy",
    stroke: "#3F51B5",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.467577,
    y1: 61.0443686,
    x2: 257.467577,
    y2: 18.623312,
    id: "Line-Copy-4",
    stroke: "#3F51B5",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.152322191,
    y1: 37.1945392,
    x2: 20.9488055,
    y2: 42.7530048,
    id: "Line-Copy-2",
    stroke: "#3F51B5",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.251298,
    y1: 7.20819113,
    x2: 281.34471,
    y2: 0.316010969,
    id: "Line-Copy-5",
    stroke: "#3F51B5",
    strokeWidth: 3,
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV1ShruggingCloudIcon);
export default __webpack_public_path__ + "static/media/V1Shrugging-cloud-icon.46eb4c33a3c7d4f32ad5daea465e000e.svg";
export { ForwardRef as ReactComponent };